export default __webpack_public_path__ + "static/media/barbados-integrated-government.9deceacd.png";